const initialState = {
    logginIn: false
};

export const loginReducer = (state = initialState, action) => {

    return state;
    /*
    switch (action.type) {

    }*/
}


// WEBPACK FOOTER //
// ./src/reducers/loginReducer.js